import script from "./pageNewsGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./pageNewsGallery.vue?vue&type=script&setup=true&lang=js"

import "./pageNewsGallery.vue?vue&type=style&index=0&id=864a352e&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-864a352e"]])

export default __exports__